import {storeToRefs} from 'pinia';

import {useTariffsStore} from '@/store/tariffs';
import {cellFormatters} from './cell_formatters';
import {getGroupedRow as groupedRow, getRow as row} from '@/tariffs/table';

export const regionalTariffs = {
    getRowGroups: () => {
        const fmt = cellFormatters.value;

        const tariffsStore = useTariffsStore();
        const {yearly, hourly} = storeToRefs(tariffsStore);
        const {occupationCostsRowIsVisible} = tariffsStore;

        return [
            groupedRow(
                {
                    name: 'page2_subheading_net_lw',
                    // defaultToggle: true,
                },
                [
                    row(
                        {
                            name: 'page2_net_lw',
                            toggleable: true,
                        },
                        [
                            fmt.currency(hourly.value.livingWages.net),
                            fmt.currency(yearly.value.livingWages.net),
                        ],
                    ),
                    row(
                        {
                            name: 'page2_nr_working_days_py',
                            toggleable: true,
                        },
                        [null, fmt.days(yearly.value.totalWorkDays)],
                    ),
                    row(
                        {
                            name: 'page2_nr_festive_days_py',
                            toggleable: true,
                        },
                        [null, fmt.days(yearly.value.publicHolidays)],
                    ),
                    row(
                        {
                            name: 'page2_nr_leavedays_py',
                            toggleable: true,
                        },
                        [null, fmt.days(yearly.value.leaveDays)],
                    ),
                    row(
                        {
                            name: 'page2_nr_ftworking_days_py',
                            toggleable: true,
                        },
                        [null, fmt.days(yearly.value.totalWorkDaysMinusDaysOff)],
                    ),
                    row(
                        {
                            name: 'page2_nr_ftworking_hours_py',
                            toggleable: true,
                        },
                        [null, fmt.hours(yearly.value.fullTimeWorkingHours)],
                    ),
                    row(
                        {
                            name: 'page2_lt_without_overhead',
                            hasTotalAmount: true,
                        },
                        [
                            fmt.currency(
                                hourly.value.livingWages.withoutOverhead
                            ),
                            fmt.currency(yearly.value.livingWages.withoutOverhead),
                        ],
                    ),
                ]
            ),
            groupedRow(
                {
                    name: 'page2_jobrelated_costs',
                    visible: occupationCostsRowIsVisible(),
                },
                [
                    row(
                        {
                            name: 'page2_cost_computer',
                            visible: occupationCostsRowIsVisible('computer'),
                            toggleable: true,
                        },
                        [
                            fmt.currency(hourly.value.jobRelatedCosts.computer),
                            fmt.currency(yearly.value.jobRelatedCosts.computer),
                        ]
                    ),
                    row(
                        {
                            name: 'page2_cost_phone',
                            visible: occupationCostsRowIsVisible('phone'),
                            toggleable: true,
                        },
                        [
                            fmt.currency(hourly.value.jobRelatedCosts.phone),
                            fmt.currency(yearly.value.jobRelatedCosts.phone),
                        ]
                    ),
                    row(
                        {
                            name: 'page2_cost_car',
                            visible: occupationCostsRowIsVisible('car'),
                            toggleable: true,
                        },
                        [
                            fmt.currency(hourly.value.jobRelatedCosts.car),
                            fmt.currency(yearly.value.jobRelatedCosts.car),
                        ]
                    ),
                    row(
                        {
                            name: 'page2_cost_scooter',
                            visible: occupationCostsRowIsVisible('scooter'),
                            toggleable: true,
                        },
                        [
                            fmt.currency(hourly.value.jobRelatedCosts.scooter),
                            fmt.currency(yearly.value.jobRelatedCosts.scooter),
                        ]
                    ),
                    row(
                        {
                            name: 'page2_cost_ebicycle',
                            visible: occupationCostsRowIsVisible('electricBicycle'),
                            toggleable: true,
                        },
                        [
                            fmt.currency(hourly.value.jobRelatedCosts.electricBicycle),
                            fmt.currency(yearly.value.jobRelatedCosts.electricBicycle),
                        ]
                    ),
                    row(
                        {
                            name: 'page2_cost_bicycle',
                            visible: occupationCostsRowIsVisible('bicycle'),
                            toggleable: true,
                        },
                        [
                            fmt.currency(hourly.value.jobRelatedCosts.bicycle),
                            fmt.currency(yearly.value.jobRelatedCosts.bicycle),
                        ]
                    ),
                    row(
                        {
                            name: 'page2_total_job_related_cost',
                            visible: occupationCostsRowIsVisible(),
                            hasTotalAmount: true,
                        },
                        [
                            fmt.currency(hourly.value.jobRelatedCosts.total),
                            fmt.currency(yearly.value.jobRelatedCosts.total),
                        ]
                    ),
                ],
            ),
            groupedRow(
                {
                    name: 'page2_jobrelated_costs_time',
                },
                [
                    row(
                        {
                            name: 'page2_dayspy_administration',
                            toggleable: true,
                        },
                        [
                            fmt.minutes(hourly.value.jobRelatedMinutes.administration),
                            fmt.days(yearly.value.jobRelatedDays.administration),
                        ]
                    ),
                    row(
                        {
                            name: 'page2_dayspy_acquisition',
                            toggleable: true,
                        },
                        [
                            fmt.minutes(hourly.value.jobRelatedMinutes.acquisition),
                            fmt.days(yearly.value.jobRelatedDays.acquisition),
                        ]
                    ),
                    row(
                        {
                            name: 'page2_dayspy_training',
                            toggleable: true,
                        },
                        [
                            fmt.minutes(hourly.value.jobRelatedMinutes.training),
                            fmt.days(yearly.value.jobRelatedDays.training),
                        ]
                    ),
                    row(
                        {
                            name: 'page2_minutesph_waiting_time',
                            toggleable: true,
                        },
                        [
                            fmt.minutes(hourly.value.jobRelatedMinutes.waiting),
                            fmt.days(yearly.value.jobRelatedDays.waiting),
                        ]
                    ),
                    row(
                        {
                            name: 'page2_jobrelated_time_total',
                            toggleable: true,
                        },
                        [
                            fmt.minutes(hourly.value.jobRelatedMinutes.total),
                            fmt.days(yearly.value.jobRelatedDays.total),
                        ]
                    ),
                    row(
                        {
                            name: 'page2_adjusted_fulltime_workhours',
                            toggleable: true,
                        },
                        [
                            null,
                            fmt.hours(yearly.value.workHoursAdjustedForUnpaidTime),
                        ]
                    ),
                    row(
                        {
                            name: 'page2_jobrelated_costs_total',
                            hasTotalAmount: true,
                        },
                        [
                            fmt.currency(hourly.value.totalOverheadCosts),
                            null,
                        ]
                    ),
                    row(
                        {
                            name: 'page2_lt_without_tax',
                            isHighlighted: true,
                        },
                        [
                            fmt.currency(
                                hourly.value.livingWages.withCostsAndOverhead
                            ),
                            fmt.currency(yearly.value.livingWages.withCostsAndOverhead),
                        ]
                    ),
                ]
            ),
            groupedRow(
                {
                    name: 'page2_cost_social_security'
                },
                [
                    row(
                        {
                            name: 'page2_perc_income_taxes',
                            toggleable: true,
                        },
                        [
                            fmt.currency(hourly.value.livingWages.incomeTax),
                            fmt.currency(yearly.value.livingWages.incomeTax),
                        ],
                    ),
                    row(
                        {
                            name: 'page2_reservation_pension',
                            toggleable: true,
                        },
                        [
                            fmt.currency(
                                hourly.value.livingWages.socialContributions['pension']
                            ),
                            fmt.currency(
                                yearly.value.livingWages.socialContributions['pension']
                            ),
                        ],
                    ),
                    row(
                        {
                            name: 'page2_reservation_sickness',
                            toggleable: true,
                        },
                        [
                            fmt.currency(
                                hourly.value.livingWages.socialContributions['sickness']
                            ),
                            fmt.currency(
                                yearly.value.livingWages.socialContributions['sickness']
                            ),
                        ],
                    ),
                    row(
                        {
                            name: 'page2_reservation_disability',
                            toggleable: true,
                        },
                        [
                            fmt.currency(
                                hourly.value.livingWages.socialContributions['g commitggcogg']
                            ),
                            fmt.currency(
                                yearly.value.livingWages.socialContributions['disability']
                            ),
                        ],
                    ),
                    row(
                        {
                            name: 'page2_reservation_no_work',
                            toggleable: true,
                        },
                        [
                            fmt.currency(
                                hourly.value.livingWages.socialContributions['no_work_available']
                            ),
                            fmt.currency(
                                yearly.value.livingWages.socialContributions['no_work_available']
                            ),
                        ],
                    ),
                    row(
                        {
                            name: 'page2_insurance_medical_costs',
                            toggleable: true,
                        },
                        [
                            fmt.currency(
                                hourly.value.livingWages.socialContributions['medical_insurance']
                            ),
                            fmt.currency(
                                yearly.value.livingWages.socialContributions['medical_insurance']
                            ),
                        ],
                    ),
                    row(
                        {
                            name: 'page2_total_taxes_social_security',
                            hasTotalAmount: true,
                        },
                        [
                            fmt.currency(
                                hourly.value.livingWages.incomeTaxPlusSocialContributions
                            ),
                            fmt.currency(
                                yearly.value.livingWages.incomeTaxPlusSocialContributions
                            ),
                        ],
                    ),
                    row(
                        {
                            name: 'page2_lt_with_income_tax',
                            isHighlighted: true,
                        },
                        [
                            fmt.currency(
                                hourly.value.livingWages.withIncomeTax
                            ),
                            fmt.currency(yearly.value.livingWages.withIncomeTax),
                        ]
                    ),
                ],
            )
        ];
    },
};
